export const isValidEmailAddress = (str: string | undefined | null): boolean => !!str?.match(/^\S+@\S+\.\S+$/);
